import { Box, Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Booking } from '../../api/types';
import VisitorBookingStatusChip from './VisitorBookingStatusChip';
import { useTranslation } from 'react-i18next';

const PREFIX = 'VisitorBookingCard';

const classes = {
    button: `${PREFIX}-button`,
    visitorBookingName: `${PREFIX}-visitorBookingName`,
    cardHeader: `${PREFIX}-cardHeader`,
    cardContent: `${PREFIX}-cardContent`,
};

const StyledCard = styled(Card)((
    {
        theme,
    },
) => ({
    [`& .${classes.button}`]: {
        display: 'block',
        width: '100%',
    },

    [`& .${classes.visitorBookingName}`]: {
        textOverflow: 'ellipsis',
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        boxSizing: 'border-box',
        fontWeight: 'bold',
        fontSize: '20px',
    },

    [`& .${classes.cardHeader}`]: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginBottom: 4,
    },

    [`& .${classes.cardContent}`]: {
        paddingBottom: 16,
    },
}));

interface VisitorBookingCardProps {
    visitorBooking: Booking;
    onPress: () => void;
}

const VisitorBookingCard = (props: VisitorBookingCardProps) => {
    // const navigate = useNavigate();
    const { t } = useTranslation();

    if (!props.visitorBooking) {
        return null;
    }

    const hasBeenStarted = Boolean(
        props.visitorBooking.items[0].rental && Object.keys(props.visitorBooking.items[0].rental).length > 0,
    );
    const hasBeenFinished = Boolean(
        props.visitorBooking.items[0].rental && !props.visitorBooking.items[0].rental.isActive,
    );

    return (
        <StyledCard>
            <CardContent onClick={props.onPress} className={classes.cardContent}>
                <Box className={classes.cardHeader}>
                    <Typography 
                        variant={'h6'} 
                        className={`${classes.visitorBookingName}`}
                    >
                        {props.visitorBooking.bookingNumber}
                    </Typography>
                    <VisitorBookingStatusChip 
                        label={
                            hasBeenStarted && !hasBeenFinished
                                ?
                                'Started'
                                :
                                hasBeenFinished && hasBeenStarted
                                    ?
                                    'Finished'
                                    :
                                    'Not Started'
                        } 
                    />
                </Box>
                <Box>
                    <Typography 
                        component={'span'} 
                        style={{ fontSize: '16px' }} 
                        variant={'body1'}
                    >
                        {t('visitor_booking.booking_comment_reduced')}: {`${props.visitorBooking.comment}`}
                    </Typography>
                </Box>


            </CardContent>
        </StyledCard>

    );
};

export default VisitorBookingCard;
